import { MAX_AGE, MIN_AGE } from "../constant/gms-constant";

export const generateRemainingAgeRate = (fromAge: number, toAge: number) => {
    const hasUnderMin = fromAge > MIN_AGE;
    const hasOverMax = toAge < MAX_AGE;

    const result = [
        {
            id: 1,
            label: "",
            amount: 0,
            typeOfAge: "under_min",
            value: false,
            isDefault: false,
            // isShow: hasUnderMin, // set false for now
            isShow: false
        },
        {
            id: 2,
            label: "",
            amount: 0,
            typeOfAge: "main",
            value: true,
            isDefault: false,
            isShow: true,
        },
        {
            id: 3,
            label: "",
            amount: 0,
            typeOfAge: "under_max",
            value: false,
            isDefault: false,
            isShow: hasOverMax,
        },
    ];

    // Before selected range
    if (hasUnderMin) {
        const end = fromAge - 1;
        result[0].label = MIN_AGE === end ? `${MIN_AGE}` : `${MIN_AGE}-${end}`;
    }

    // Selected range
    result[1].label = fromAge === toAge ? `${fromAge}` : `${fromAge}-${toAge}`;

    // After selected range
    if (hasOverMax) {
        const start = toAge + 1;
        result[2].label = start === MAX_AGE ? `${MAX_AGE}` : `${start}-${MAX_AGE}`;
    }

    return result;
};